import { render, staticRenderFns } from "./ReportQuizzesAndQuestions.vue?vue&type=template&id=c73b8038&scoped=true&"
import script from "./ReportQuizzesAndQuestions.vue?vue&type=script&lang=js&"
export * from "./ReportQuizzesAndQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ReportQuizzesAndQuestions.vue?vue&type=style&index=0&id=c73b8038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73b8038",
  null
  
)

export default component.exports